import WeaverService from 'Services/WeaverService'
import { message } from 'antd'

export initErrorHandlers = ->
  window.addEventListener("unhandledrejection", (error) ->

    reason = error?.detail?.reason
    reason ?= error?.reason

    # presence of a code indicates a http error response rom the server, as opposed to a client error thrown inside a promise/event handler
    willCatch = true if reason?.code

    switch reason?.code
      when Weaver.Error.NODE_NOT_FOUND
        message.error('The node you are searching for cannot be found, if you are seeing this, it was probably recently deleted by another user.')
      when Weaver.Error.INVALID_USERNAME_PASSWORD
        true
      when Weaver.Error.INVALID_SESSION_TOKEN
        WeaverService.redirectToLogin(Weaver.Error.EXPIRED_SESSION_TOKEN)
      when Weaver.Error.EXPIRED_SESSION_TOKEN
        WeaverService.redirectToLogin(Weaver.Error.EXPIRED_SESSION_TOKEN)
      when Weaver.Error.INTERNAL_SERVER_ERROR
        message.error('Something went wrong on the server')
        willCatch = false
      else
        willCatch = false

    if willCatch
      error.preventDefault()
    else
      throw Error(reason.message)
  )

dbErr = (errMsg) -> errMsg.includes("PL/pgSQL")

export parseErr = (e) ->
  if dbErr(e.message)
    trimmedStart = e.message.split("ERROR:")[1]
    trimmedStart.split("Where:")[0]
  else
    e.message
